import { useEffect, useState } from "react";
import { popup, useRawLaunchParams } from "@tma.js/sdk-react";
import { browserTelegramInitData, resolveTelegramChatId } from "@/utils/telegramIdentity";

export function useTelegramChatId() {
  const [chatId, setChatId] = useState<string | null>(null);
  const rawInitData = useRawLaunchParams();

  useEffect(() => {
    const startParam = new URLSearchParams(rawInitData).get(
      "tgWebAppStartParam",
    );
    const chatId = resolveTelegramChatId(startParam, browserTelegramInitData(rawInitData));
    if (!chatId) {
      popup.show({ message: "Telegram chat id not available." });
      return;
    }
    setChatId(String(chatId));
  }, [rawInitData]);

  return chatId;
}
